<template>
  <div class="payment">
    <main-text>Вы можете приобрести лицензию в отделе продаж</main-text>

    <div class="payment-contacts">
      <div class="payment-contacts-card">
        <main-text color="gray-2">Телефон</main-text>
        <main-text>8 800 775-83-51</main-text>
      </div>
      <div class="payment-contacts-card">
        <main-text color="gray-2">Время работы</main-text>
        <main-text>9:00 - 18:00 (МСК)</main-text>
      </div>
    </div>

    <main-text>Также вы можете приобрести лицензцию онлайн на сайте</main-text>
    <a href="https://mst.su/firerisks/buy/" class="payment-link" target="_blank">Перейти на сайт</a>
  </div>
</template>

<style scoped>
.payment {
  padding-top: 24px;
}
.payment-contacts {
  margin-top: 16px;
  margin-bottom: 48px;
  display: flex;
  gap: 48px;
}
.payment-link {
  display: inline-block;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  margin-top: 16px;
  padding: 10px 24px;
  border-radius: 4px;
  background-color: var(--secondary-color);
  color: var(--white-color);
  text-decoration: underline;
  transition: background-color 0.15s ease-out;
}
.payment-link:hover {
  background-color: var(--secondary-hover-color);
}
</style>

<script>
import Text from "./ui/Text.vue";
export default {
  components: {
    "main-text": Text,
  },
};
</script>
